import { createActionThunk } from 'redux-thunk-actions';

import {
  FETCH_PLATFORM_SETTINGS_PUBLIC,
  FETCH_PLATFORM_SETTINGS_ADMIN,
  UPDATE_PLATFORM_SETTINGS,
} from '../types/platformSettingsTypes';
import PlatformSettingsService from '../../../services/platformSettings';

export const fetchPlatformSettingsPublic = createActionThunk(
  FETCH_PLATFORM_SETTINGS_PUBLIC,
  () => PlatformSettingsService.fetchPublicSettings().then((data) => data),
  false,
);

export const fetchPlatformSettingsAdmin = createActionThunk(
  FETCH_PLATFORM_SETTINGS_ADMIN,
  () => PlatformSettingsService.fetchAdminSettings().then((data) => data),
  false,
);

export const updatePlatformSettings = createActionThunk(
  UPDATE_PLATFORM_SETTINGS,
  (data) => PlatformSettingsService.updateSettings(data).then((res) => res),
  false,
);
